// extracted by mini-css-extract-plugin
module.exports = {"container":"toggle_container__3JLvj","checkbox":"toggle_checkbox__Nvzvm","slidebg2":"toggle_slidebg2__32jmq","slidebg":"toggle_slidebg__NaLFg"};